// Wildcard acceleration V1; 2026-10-29 22:22 CST; parent c318343319b6812e0aba7ab02fbf64b65aca0196.
/* HotX 域名源站 Payload 备份注释
 * 注释时间：2026-08-29 20:52 CST
 * 当前文件服务域名管理页：把用户填写的源站、端口、协议、回源地址和接入配置整理成后端提交 payload。
 * 维护边界：这里不保存证书重签状态，不写入 ACME 订单状态，只负责域名/源站提交参数的规范化。
 */


/* HotX 域名源站提交跑通注释
 * 注释时间：2026-08-29 20:52 CST
 * 当前辅助逻辑服务于域名管理页：把用户填写的源站、端口、协议和接入参数整理成后端可接受的提交 payload。
 * 后续维护不要在这里塞证书重签状态；证书重签置顶和签发中反馈属于 HttpsView.vue。
 */
import type { OriginCreatePayload, OriginProtocol } from '../api/types';

// 域名管理源站首配参数整理，注释更新时间：2026-08-29 20:52 CST。
// DomainsView 只收集表单意图，这里统一清洗协议、Host、TLS SNI 和占位值，避免页面层散落接口入参规则。
export interface OriginFormState {
  originType: string;
  originAddress: string;
  originPort: number;
  host: string;
  tlsSni: string;
  protocol: string;
  originPath: string;
  weight: number;
  priority?: number | null;
  connectTimeoutMs: number;
  readTimeoutMs: number;
  sendTimeoutMs: number;
}

const HTTPS_PROTOCOLS = new Set<OriginProtocol>(['HTTPS', 'HTTP_HTTPS']);

export function buildOriginCreatePayload(
  form: OriginFormState,
  domainId: number,
  selectedDomain: string
): OriginCreatePayload {
  const originType = form.originType || 'PRIMARY';
  const protocol = normalizeProtocol(form.protocol);
  const host = normalizeAdvancedDomain(form.host, '回源 Host') || (selectedDomain.trim().startsWith('*.') ? '$host' : selectedDomain.trim());
  const tlsSni = normalizeAdvancedDomain(form.tlsSni, 'TLS SNI');
  const priority = originType === 'PRIMARY' ? 1 : form.priority || 100;

  if (!host) {
    throw new Error('请选择有效域名后再新增源站');
  }

  return {
    domainId,
    originType,
    originAddress: normalizeRequiredText(form.originAddress, '源站地址'),
    originPort: form.originPort,
    host,
    ...(HTTPS_PROTOCOLS.has(protocol) ? { tlsSni: tlsSni || host } : {}),
    protocol,
    originPath: form.originPath,
    weight: form.weight,
    priority,
    connectTimeoutMs: form.connectTimeoutMs,
    readTimeoutMs: form.readTimeoutMs,
    sendTimeoutMs: form.sendTimeoutMs
  };
}

function normalizeProtocol(value: string): OriginProtocol {
  if (value === 'HTTP' || value === 'HTTPS' || value === 'HTTP_HTTPS') {
    return value;
  }
  throw new Error('回源协议只支持 HTTP、HTTPS 或 HTTP+HTTPS');
}

function normalizeRequiredText(value: string, label: string): string {
  const normalized = value.trim();
  rejectPlaceholder(normalized, label);
  if (!normalized) {
    throw new Error(`${label}不能为空`);
  }
  return normalized;
}

function normalizeAdvancedDomain(value: string, label: string): string {
  const normalized = value.trim();
  rejectPlaceholder(normalized, label);
  return normalized;
}

function rejectPlaceholder(value: string, label: string) {
  if (/^\?{2,}$/.test(value)) {
    throw new Error(`${label} 不能使用 ?? 或 ??? 这类占位值`);
  }
}
